import { fontStyles, globalStyles } from 'styles/theme';

import { mobileMediaQuery } from 'utils/common';
import styled from '@emotion/styled';

export const Container = styled.div({
  backgroundColor: globalStyles.colors.black,
  padding: '8px 0',
  paddingLeft: 160,
  [mobileMediaQuery]: {
    paddingLeft: 20,
  },
  '& a': {
    color: globalStyles.colors.white,
    fontSize: fontStyles.sizes.xs,
  },
});
